const commands = new Map();
export function registerCommand(id, command) {
    if (commands.has(id)) {
        throw new Error(`Command '${id}' is already registered.`);
    }
    commands.set(id, command);
}
export function unregisterCommand(id) {
    if (commands.has(id)) {
        commands.delete(id);
    }
}
export function executeCommand(id, args = []) {
    if (!commands.has(id)) {
        throw new Error(`Executing unknown command '${id}'`);
    }
    const cmd = commands.get(id);
    cmd.func(...args);
}
